import React from 'react';
import PropTypes from 'prop-types';

import FreeShippingProgress from './components/FreeShippingProgress/FreeShippingProgress';

/**
 * Wrapper component to determine if Free Shipping Upsell or
 *  Free Shipping Progress should be displayed
 */
const FreeShipping = ({
  className,
  backgroundColor,
  showProgress,
  shippingPolicy,
  currencyCode,
  currencySymbol,
  ...props
}) => {
  if (showProgress) {
    return (
      <FreeShippingProgress
        className={className}
        currencyCode={currencyCode}
        currencySymbol={currencySymbol}
        {...props}
      />
    );
  }

  return null;
};

FreeShipping.propTypes = {
  className: PropTypes.string,
  /**
   * background color option for Upsell component
   */
  backgroundColor: PropTypes.string,
  /**
   * `true` to display shipping progress
   * when free shipping is not enabled
   */
  showProgress: PropTypes.bool,
  /**
   * shipping policy from contentful
   */
  shippingPolicy: PropTypes.shape({
    cta: PropTypes.string,
    display: PropTypes.bool,
    title: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.shape({})),
    defaultSection: PropTypes.shape({})
  }),
  /**
   * Currency Code for User's Country
   */
  currencyCode: PropTypes.string,
  /**
   * Currency Symbol for User's Country. Either $ or CA$.
   */
  currencySymbol: PropTypes.oneOf(['$', 'CA$'])
};

FreeShipping.defaultProps = {
  className: '',
  backgroundColor: undefined,
  showProgress: true, // change to true if free shipping needs to be reverted
  shippingPolicy: {},
  currencyCode: null,
  currencySymbol: null
};

export default FreeShipping;
